import React, { createContext, useReducer } from 'react';
import { IStoreState } from 'src/@reports/interfaces';
import { dataInitialState, dataReducer } from 'src/@reports/reducers/dataReducer';
import { sortInitialState, sortReducer } from 'src/@reports/reducers/sortReducer';
import { filterInitialState, filterReducer } from 'src/@reports/reducers/filterReducer';
// Hooks
import { usePersistentReducer } from 'src/utils';

export const ReportsStateContext = createContext({
  data: dataInitialState,
});

export const ReportsDispatchContext = createContext(null);

export const ReportsStateProvider = ({ children }) => {
  const [dataState, dataDispatch] = useReducer(dataReducer, dataInitialState);
  const [sortState, sortDispatch] = useReducer(sortReducer, sortInitialState);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [filterState, filterDispatch] = usePersistentReducer(
    filterReducer,
    filterInitialState,
    'reports.filter.state',
    'session'
  );

  const state: IStoreState = {
    data: dataState,
    sort: sortState,
    filter: filterState,
  };

  const dispatchers = [dataDispatch, sortDispatch, filterDispatch];

  const dispatch: any = (action: any) =>
    dispatchers.map((dispatcher: any) => {
      dispatcher(action);
    });

  return (
    <ReportsStateContext.Provider value={state}>
      <ReportsDispatchContext.Provider value={dispatch}>{children}</ReportsDispatchContext.Provider>
    </ReportsStateContext.Provider>
  );
};
